export default {
  company: {
    search: {
      companyName: '公司名称',
      companyNamePlaceholder: '请输入公司名称',
      companyCode: '公司编码',
      companyCodePlaceholder: '请输入公司编码',
      status: '状态',
      statusPlaceholder: '请选择状态',
      controlName: '控制范围名称',
      controlNamePlaceholder: '请输入控制范围名称',
      receiptClaimMode: '请选择收款认领模式',
    },
    title: '搜索结果',
    companyInfo: '公司信息',
    departmentInfo: '部门信息',
    controlRangeInfo: '控制范围信息',
    system: '系统映射表',
    history: '历史记录',
    noExportTips: '请至少选择一列导出',
    detail: {
      receiptClaimMode: '收款认领模式',
      companyCode: '公司编码',
      companyStatus: '当前状态',
      companyName: '公司名称',
      companyAddress: '公司地址',
      companyNational: '国家',
      creditCode: '统一社会信用代码',
      companyIndex: '序列优先级',
      departmentCode: '部门编码',
      departmentName: '部门名称',
      controlCode: '控制范围编码',
      controlName: '控制范围名称',
      controlAreaCode: '控制范围代码',
    },
    departmentTitle: '下属部门',
    higherDepartmentTitle: '上级单位',
    controlRangeTitle: '关联部门',
    controlTitle: '所属控制范围',
    controlareaName: '控制范围名称',
    table: {
      departmentName: '部门名称',
      unitName: '单位名称',
      controlareaName: '控制范围名称',
    },
    editTips: '请选择一条记录修改',
    fotbidNoTips: '请选择一条记录禁用',
    fotbidNoReason: '只有已生效的才能禁用',
    liftNoReason: '只有已禁用的才能启用',
    adminReason: '只有管理员才能启用！',
    addError: '只能新增到第四级部门',
    editNoTips: '请选择一条记录修改',
    noUnitData: '上级单位只能有一条',
    fotbidTips: '当前状态已经是禁用,请重新选择',
    notForbidChild: '不能禁用控制范围下的部门',
    liftNoTips: '请选择一条记录启用',
    liftTips: '当前状态已经是启用,请重新选择',
    insertCompany: '新增公司',
    insertDepartment: '新增部门',
    insertControl: '新增控制范围',
    companyNamePlaceholder: '请输入公司名称',
    companyAddressPlaceholder: '请输入公司地址',
    companyNationalPlaceholder: '请选择国家',
    creditCodePlaceholder: '请输入统一社会信用代码',
    creditCodeNotEmpty: '统一社会信用代码不能为空',
    companyNationalNotEmpty: '国家不能为空',
    companyNameNotEmpty: '公司名称不能为空',
    controlAreaNamePlaceholder: '请输入控制范围名称',
    controlAreaCodePlaceholder: '请输入控制范围代码',
    controlAreaNameNotEmpty: '控制范围名称不能为空',
    controlAreaCodeNotEmpty: '控制范围代码不能为空',
    controlAreaCodeError: '控制范围代码格式不正确',
    contractPersonWordNumber: '长度在 1 到 32 个字符',
    companyNameWordNumber: '长度在 1 到 64 个字符',
    companyAddressWordNumber: '长度在 1 到 256 个字符',
    storageAddressWordNumber: '长度在 1 到 128 个字符',
    departmentNamePlaceholder: '请输入部门名称',
    departmentNameNotEmpty: '部门名称不能为空',
    UnitNotEmpty: '单位名称不能为空',
    controlAreaNotEmpty: '控制范围名称不能为空',
    departmentPlaceholder: '请输入部门编码或名称搜索',
    companyPlaceholder: '请输入公司编码或名称搜索',
    controlAreaPlaceholder: '请输入控制范围编码或名称搜索',
    companySameData: '请勿添加相同的公司',
    departmentSameData: '请勿添加相同的部门',
    controlAreaSameData: '请勿添加相同的控制范围',
    treeselect: {
      searchIndex: '请输入关键字搜索',
      noData: '无匹配数据',
    },
  },
  department: {
    search: {
      departmentName: '部门名称',
      departmentNamePlaceholder: '请输入部门名称',
      departmentCode: '部门编码',
      departmentCodePlaceholder: '请输入部门编码',
      organization: '组织架构',
      organizationPlaceholder: '请选择组织架构',
      status: '状态',
      statusPlaceholder: '请选择状态',
    },
  },
  warehouse: {
    search: {
      warehouseCode: '仓库编码',
      warehouseCodePlaceholder: '请输入仓库编码',
      warehouseName: '仓库名称',
      warehouseNamePlaceholder: '请输入仓库名称',
      isDirectDeliver: '是否直拨',
      isDirectDeliverPlaceholder: '请选择是否直拨',
    },
    table: {
      email: '邮箱',
      faxNo: '传真',
      createWarehouseCode: '仓库编码',
      createWarehouseName: '仓库名称',
      isDirectDeliver: '是否直拨',
      createWarehouseAddress: '仓库地址',
      createWarehouseCompanyCode: '仓储公司编码',
      createWarehouseCompanyName: '仓储公司名称',
      gmtCreateBy: '创建人',
      gmtCreate: '创建时间',
      status: '状态',
      contractPerson: '联系人',
      contractTelephone: '联系电话',
    },
    email: '请输入邮箱',
    faxNo: '请输入传真',
    update: '修改',
    giveUp: '放弃',
    updateReason: '修改原因',
    warehouseInfo: '仓库信息',
    belongCompany: '所属公司',
    storageAddressPlaceholder: '请输入仓库地址',
    contractPersonPlaceholder: '请输入联系人',
    contractTelephonePlaceholder: '请输入联系电话',
    storageCompanyCodePlaceholder: '请输入仓储公司编码搜索',
    storageCompanyNamePlaceholder: '请输入仓储公司名称搜索',
    contractTelephone: '请输入联系电话',
    storageNameNotEmpty: '仓库名称不能为空',
    directNotEmpty: '直拨类型不能为空',
    storageCompanyCodeNotEmpty: '仓储公司编码',
    storageCompanyNameNotEmpty: '仓储公司名称',
    updateReasonNotEmpty: '修改原因不能为空',
    forbidReasonNotEmpty: '禁用原因不能为空',
    currentUsersCannotAdd: '新增所属公司数量已达到上限',
    forGiveSuccess: '操作成功',
    forGiveError: '放弃失败',
    forbidReason: '请输入禁用原因',
    forbid: '禁用',
    lift: '启用',
  },
};
